import { Skeleton } from '@fortune-ui'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { OrderModel } from '../../model/order-model'
import { AdminOrderBrands } from './AdminOrderBrands'
import { AdminOrderTotal } from './AdminOrderTotal'

export const AdminOrderInfo = () => {
  const { destructuredData: orders } = useAdminOrders()
  const orderModel = orders ? new OrderModel(orders) : null

  return (
    <>
      {orderModel ? <AdminOrderBrands order={orderModel} /> : <Skeleton height="384px" variant="rounded" />}
      <AdminOrderTotal />
    </>
  )
}
